module.exports = __webpack_public_path__ + "static/media/Event.2c88f84e.svg";